import { Link, useLocation, useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";
import { getCountry, guvenlikSayfasiAcikMi } from "../country";
import { secilebilirDiller, DIL_ETIKETLERI } from "../dilSecimi";
import { useAuth } from "../auth";
import useOkunmamisSayac, { okunmamisTazele } from "../hooks/useOkunmamisSayac";
import { ORTA_DUGME, ORTA_ETIKET } from "../lib/altBar";
import { kediProfiliMi } from "../lib/kediSekmeleri";
import { MapPin, Sparkles, Eye, Utensils, LayoutDashboard, LogIn, LogOut, UserPlus, Menu, X, Database, UserCircle2, Trophy, Siren, BellRing, HandHeart, MessageSquare, ShieldCheck, PawPrint, Shield, EyeOff, Home, Plus, Users } from "lucide-react";
import PatiAsistan from "./PatiAsistan";
import AnimalToggleModal from "./AnimalToggleModal";
import { getAnimalMode, setAnimalMode, kopekAcikMi } from "../animalMode";
import { LiveCameraShutterProvider } from "../context/LiveCameraShutterContext";
import UploadProgressBar from "./UploadProgressBar";
import CatMilestoneModal from "./FirstCatMilestone";
import { useState, useEffect, useRef } from "react";
import { Button } from "../components/ui/button";
import NotificationBell from "./NotificationBell";
import { useBadgeCelebration } from "../hooks/useBadgeCelebration";
import { markaAdi, markaLogosu } from "../lib/marka";

// Drawer (hamburger) destinations — order = discovery priority.
const drawerLinks = [
  { to: "/map", key: "nav.map", icon: MapPin, color: "text-blue-600" },
  { to: "/feeding", key: "nav.feeding", icon: Utensils, color: "text-orange-600" },
  { to: "/observation-house", key: "nav.observationHouse", icon: Home, color: "text-amber-700" },
  // 4 Eyl 2026: `/scan-cat` degil. Alt bardaki orta dugme 1 Agu'da
  // `/kedi-kimligi`ye cevrilmisti; AYNI ETIKETI tasiyan bu giris
  // cevrilmemis, kullanici footer'dan basinca baska sayfa aciliyordu.
  // Kural: src/lib/aramaKapsam.test.js — etiket ayniysa hedef de ayni.
  { to: "/kedi-kimligi", key: "nav.identify", icon: Sparkles, color: "text-orange-600" },
  { to: "/cats", key: "nav.database", icon: Database, color: "text-stone-600" },
  { to: "/leaderboard", key: "nav.leaderboard", icon: Trophy, color: "text-blue-600" },
  { to: "/volunteers", key: "nav.volunteers", icon: HandHeart, color: "text-rose-600" },
  { to: "/badges", key: "nav.badges", icon: PawPrint, color: "text-amber-600" },
  { to: "/safety", key: "nav.safety", icon: Shield, color: "text-emerald-700" },
];

// Footer sütunları 6 Eyl 2026'da footer'la birlikte kalktı
// (`footerDiscoverLinks` / `footerCommunityLinks` / `_byPath`). Kullanılmayan
// sabitleri bırakmak, derlemeyi uyarıyla geçen ölü kod bırakmaktır.

// GÜVENLIK-1: guvenlik rehberi yalnizca Turkiye'de. Liste modul yuklenirken
// bir kez degil, HER cagride suzuluyor — kullanici ulke ekranindan secim
// yapinca sayfa zaten yeniden yukleniyor, ama modul seviyesinde dondurmak
// ileride sessiz bir hataya donusurdu.
const guvenlikDisi = (list) =>
  guvenlikSayfasiAcikMi() ? list : list.filter((l) => l.to !== "/safety");

/**
 * The phone buzzes and the bell shakes when Acil is tapped.
 *
 * Not decoration. This is a native <a> doing a full-page navigation, and in an
 * Android WebView that can take a visible beat. Someone standing over a bleeding
 * cat who presses the button and feels nothing happen will press it again, and
 * again, and start to believe the app is broken. The buzz is the receipt: it
 * lands in the same instant as the finger, before any network does anything.
 */
function triggerEmergencyTapHaptic() {
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(35);
    }
  } catch {
    /* Vibration API unsupported or blocked — silent noop (e.g. iOS Safari). */
  }
}

function playEmergencyBellShake(bellEl) {
  if (!bellEl) return;
  // Remove, force a reflow, re-add. Without the reflow the browser coalesces the
  // class removal and addition into no change at all, and the animation only
  // ever plays once — on the first tap of the session.
  bellEl.classList.remove("emergency-mobile-link__bell--shake");
  void bellEl.offsetWidth;
  bellEl.classList.add("emergency-mobile-link__bell--shake");
}

/**
 * KENDI KABUGUNU TASIYAN sayfalarin rotalari — Layout bunlarda kendi
 * basligini ve alt cubugunu CIZMEZ.
 *
 * Kural iki yonlu ve iki yonu de canli hata uretti:
 *
 *   Fazla giren -> IKI BASLIK + iki alt cubuk. AnasayfaV2 kendi kabugunu
 *                  tasidigi halde liste ona bakmiyordu; 5 Eyl'de cihazda
 *                  ekran goruntusuyle yakalandi.
 *   Eksik cikan -> HIC BASLIK, hic alt cubuk. `Landing.jsx` kendi basligini
 *                  cizmez (dil secici bile Layout'tadir), bu yuzden "/"
 *                  Landing'e bagliyken bu listede DURAMAZ. 5 Eyl'de yerelde
 *                  tam olarak bu duruyordu.
 *
 * Yani liste, App.js'teki rota tablosunun turevidir; elle tutulan ikinci bir
 * gercek degildir. `Layout.kabuk.test.js` ikisini karsilastirir: kabugunu
 * kendi cizen sayfa `export const KENDI_KABUGU = true` yazar, test de o
 * beyani bu listeyle esler.
 */
// `/kayip/:id/ai-karsilastirma` degisken parcali oldugu icin listeye
// KOYULAMAZ — onun yerine on ek kontrolu (asagida `v2mi`).
//
// ── ANASAYFA VE İLAN DETAYI BU KAPSAMIN DIŞINDA (5 Eyl 2026, CİHAZDA karar)
//
// İkisi de GEZİNME sayfası: uygulamanın kabuğunu taşımalılar — büyük logo,
// parlayan ACİL hapı, altta "YZ Tanı" ve mesaj rozeti. Cihazda görüldü:
// kayıp ilanı detayında alt çubuk hiç yoktu ve sayfanın kendi küçük ACİL
// hapı, Layout'un parlayan hapının yerine geçiyordu. Kullanıcı uygulamanın
// içinde kaybolmuş oluyor: nereye döneceğini gösteren çubuk yok.
//
// `/kayip/` ALTINDAKİLER için 5 Eylül'de "hepsi AKIŞ" denmişti: AI
// karşılaştırma, arama alanı ve ihbar formu; üçünün de kendi eylem çubuğu
// var, altta ikinci bir çubuk üstlerine binerdi.
//
// 6 EYLÜL'DE PANO BUNU İKİYE BÖLDÜ. Kayıp panosunun ÜÇ ekranında da
// (ilan detayı · arama alanı · AI karşılaştırma) alt çubuk çizili. Çakışma
// gerçekten vardı ama kaynağı SABİT çubuklardı; panoda o düğmeler akışın
// içinde, sayfanın sonunda. Sabit çubuk kalkınca çakışma da kalkıyor.
//
// Dışarıda kalan tek ekran ihbar FORMU: "İhbarı gönder" çubuğu formun
// altında sabit durmak zorunda (klavye açıkken de görünür kalıyor).
//
// Bu yüzden ayrım artık DERİNLİKTEN DEĞİL, AÇIK LİSTEDEN
// (`KENDI_BASLIGI_ALT_EKRANLAR`): "hangi ekran hangi kabuk" sorusu bir kez
// sorulup yazılıyor. Derinlikten türetilseydi yeni bir alt ekran eklendiği
// gün kimse o soruyu sormayacaktı.
//
// ── BÖLGE DETAYI (6 Eyl 2026, PANODAN karar) ───────────────────────────────
//
// `/bolge/<yer>` iki parça, yani yukarıdaki derinlik kuralına göre Layout
// kabuğunu alırdı. Ama PANO (`TASARIM-mahallem-2ekran.jpg`, sağ ekran) o
// ekranı TAM EKRAN HARİTA + alt sayfa olarak çiziyor: ne uygulama başlığı
// ne alt çubuk var, kendi geri oku var.
//
// Bu yüzden eşik ÖN EK BAŞINA yazılıyor. Sabit bir "> 2" yerine açık bir
// tablo: kuralın parametresi görünür oluyor ve yeni bir ön ek eklerken
// "kaçıncı parçadan sonra?" sorusu bir kez soruluyor.
//
// ── ÜÇÜNCÜ KABUK: "KENDİ BAŞLIĞI, LAYOUT'UN ÇUBUĞU" (6 Eyl 2026) ──────────
//
// Panolar üç ayrı kabuk gösteriyor, ikisi değil:
//   • Benim Mahallem  → BÜYÜK başlık + alt çubuk        (Layout'un ikisi de)
//   • Bölge detayı    → hiçbiri, kendi geri oku          (KENDI_KABUGU)
//   • Kayıp ilanı     → KENDİ küçük başlığı (‹ Kayıp Kedi · ACİL · ⋯)
//                       ama ALTTA Layout'un çubuğu       ← BU
//
// Üçüncüsü bugüne kadar yoktu ve sonucu ekranda İKİ BAŞLIK oluyordu:
// Layout'un büyük logolu başlığı, hemen altında sayfanın kendi geri oku.
// Yan yana karşılaştırmada görüldü.
//
// Alt çubuk BİLEREK duruyor: kullanıcı 5 Eylül'de tam olarak bunu istemişti
// ("alt menu ve acil butonu ana sayfada ki gibi gozukmeli") ve panoda da
// alt çubuk var. Kaldırılan tek şey ÜSTTEKİ ikinci başlık.
//
// ── ARAMA ALANI DA BU KABUĞA GİRDİ (6 Eyl 2026, PANO ekran 2) ─────────────
//
// `/kayip/<id>/arama-alani` derinlik kuralına göre AKIŞ sayılıp kabuksuz
// kalıyordu. Gerekçe şuydu: "kendi birincil eylem çubuğu var (sabit alttaki
// 'İhbar ekle'), Layout'unki onun üstüne binerdi."
//
// Pano bunu başka türlü çözüyor: iki eylem düğmesi ("İhbar ekle" ve "Arama
// ekibine katıl") SABİT DEĞİL, içeriğin akışında, listenin altında duruyor;
// en altta da uygulamanın kendi çubuğu var. Yani çakışma sabit çubuktan
// geliyordu, sayfanın kendisinden değil — düğmeler akışa alınınca sorun
// ortadan kalkıyor ve kullanıcı ekranın dibinde uygulamanın içinde kalıyor.
//
// AI karşılaştırma ve ihbar formu KAPSAM DIŞI: onlar gerçekten tek işli
// akışlar (fotoğraf çek / formu gönder) ve kendi kabuklarını taşıyorlar.
// Bu yüzden kural "üç parçadan sonrası akış" değil, AÇIK BİR LİSTE:
// hangi alt ekranın uygulamanın kabuğunu taşıdığı tek tek yazılıyor.
const KENDI_BASLIGI_ON_EKLERI = ["/kayip/"];
/** `/kayip/<id>/<son>` içinde uygulamanın kabuğunu taşıyan alt ekranlar.
 *
 * Pano kayıp akışının ÜÇ EKRANINDA DA alt çubuğu çiziyor (ilan detayı,
 * arama alanı, AI karşılaştırma). Dışarıda kalan tek ekran ihbar FORMU:
 * onun kendi "İhbarı gönder" çubuğu var ve Layout'unki üstüne binerdi.
 * Liste açık tutuluyor ki "hangi ekran hangi kabuk" sorusu bir kez
 * sorulup yazılsın, derinlikten türetilmesin. */
const KENDI_BASLIGI_ALT_EKRANLAR = ["arama-alani", "ai-karsilastirma"];
const parcaSayisi = (yol) => yol.split("/").filter(Boolean).length;
const kendiBasligiMi = (yol) =>
  KENDI_BASLIGI_ON_EKLERI.some((o) => {
    if (!yol.startsWith(o)) return false;
    const p = yol.split("/").filter(Boolean);
    if (p.length === 2) return true;                       // /kayip/<id>
    return p.length === 3 && KENDI_BASLIGI_ALT_EKRANLAR.includes(p[2]);
  });

/**
 * KARAR 12 — SOHBET EKRANINDA ALT CUBUK VE PATI ASISTANI CIZILMIYOR
 * ------------------------------------------------------------------
 * Kanit tasarimin kendisi (docs/tasarim/mesajlasma .jpg):
 *   Ekran 1 (liste)  -> alt cubuk VAR
 *   Ekran 2 (sohbet) -> alt cubuk YOK, en altta besteci var
 *
 * Cihazda olculdu (6 Eyl): ikisi birden cizilince besteci alt cubugun
 * altinda kaliyor ve gonder oku Pati Asistani rozetiyle cakisiyor
 * (rozet bottom: safe-area + 84px, tam bestecinin uzerine geliyor).
 *
 * Karar 8'i BOZMAZ: alt cubugun gorunumu ve davranisi degismedi;
 * yalnizca tasarimda zaten bulunmadigi ekranlarda cizilmiyor.
 * Liste ekranlari (/mesajlar, /mesajlar/istekler) alt cubugu tasir.
 */
/**
 * KARAR 32 — KEDİ KAYDET SİHİRBAZI TAM EKRAN (9 Eyl 2026, cihaz ölçümü)
 * ---------------------------------------------------------------------
 * Kullanıcı: *"bizde çıkan sayfa bulmaca gibi duruyor, sayfayı görünce
 * uygulamayı terk edesim geliyor."*
 *
 * Cihazda ölçüldü (3/3 "Temel Bilgiler" ekranı, 739x1600 ekran görüntüsü):
 * panonun en alttaki birincil eylemi "Kediyi Kaydet →" iken uygulamada o
 * düğmenin üzerine alt çubuk (h-16 + güvenli alan), sağ üstüne yüzen ACİL
 * hapı, sağ altına Pati Asistanı biniyordu. Yani panoda TEK olan ekranda
 * dört ayrı yüzen katman vardı — "bulmaca" hissi bu.
 *
 * Panoda bu üç ekranın hiçbirinde alt çubuk YOK: kayıt sihirbazı baştan
 * sona tam ekran bir akış (2/3, 3/3 sayaçları da bunu söylüyor).
 *
 * Karar 12'nin (sohbet ekranı) aynısı, aynı gerekçeyle: tasarımda
 * bulunmadığı ekranda çizilmiyor. Alt çubuğun görünümü ve davranışı
 * DEĞİŞMİYOR; yalnız bu akışta çizilmiyor.
 *
 * Kapsam DAR tutuldu: `/scan-cat`in tamamı değil, YALNIZ üç kare toplayan
 * kayıt akışı (`state.kameraAc`). Hamburgerden, Mahallem AI kartından ya da
 * elle adres yazarak `/scan-cat`e gelen kullanıcı alt çubuğunu görmeye
 * devam ediyor — o akış tam ekran değil.
 */
const kayitSihirbaziMi = (yol, durum) =>
  yol.startsWith("/scan-cat") && Boolean(durum?.kameraAc);

const sohbetParcaSayisi = (yol) => yol.split("/").filter(Boolean).length;
const sohbetEkraniMi = (yol) =>
  (yol.startsWith("/mesajlar/") && sohbetParcaSayisi(yol) >= 2 && !yol.endsWith("/istekler")) ||
  (yol.startsWith("/messages/") && sohbetParcaSayisi(yol) >= 2) ||
  (yol.startsWith("/gruplar/") && yol.endsWith("/sohbet"));

/**
 * MESAJLASMA BOLUMU — eski ve yeni yazim BIRLIKTE.
 *
 * OLCULDU (6 Eyl 2026, gercek build uzerinde): `/messages`te site basligi ve
 * pazarlama footer'i ZATEN gizliydi (sayfa 747px). Yeni ekranlar Turkce
 * yazildigi icin (`/mesajlar`) bu kurala HIC girmiyordu:
 *
 *     /messages   app-header=gizli  app-footer=gizli  sayfa= 747
 *     /mesajlar   app-header=65px   app-footer=553px  sayfa=1365
 *
 * Sonuc ekranda IKI BASLIK ust uste ve bestecinin altinda 553px'lik
 * pazarlama footer'i. Yeni kural degil; ayni bolumun yeni yazimini mevcut
 * kurala dahil etmek.
 *
 * ALT CUBUK BUNA DAHIL DEGIL: mesajlasma bir GEZINME bolumu, alt cubugu
 * Layout vermeye devam ediyor (Karar 8).
 */
const mesajlasmaMi = (yol) =>
  yol.startsWith("/messages") ||
  yol.startsWith("/mesajlar") ||
  (yol.startsWith("/gruplar/") && yol.endsWith("/sohbet"));

// PLAN-14 Dilim A — KEDİ PROFİLİ TAM EKRAN.
//
// Profil kendi YÜZEN sekme çubuğunu çiziyor; Layout'un alt barı da çizilirse
// iki çubuk üst üste biner ve alttaki hedefler erişilemez olur — `/v2` için
// yazılan gerekçenin aynısı. Kural `lib/kediSekmeleri.js`te ve orada
// sınanıyor (`/cats`, `/cats/new`, `/cats/:id/edit` kapsam dışı).

// ZEKA-1 (15 Eyl 2026): `/ai-analiz` panoda geri oku + ortalanmis kendi
// basligini tasiyan bir ALT ekran; alt cubuk da yok. Sayfa
// `KENDI_KABUGU = true` beyan ediyor ve `Layout.kabuk.test.js` iki
// yonlu esitligi denetliyor: beyan eden her sayfanin rotasi bu listede,
// listedeki her rota beyan eden bir sayfada olmak zorunda.
// ANALIZ-8 (17 Eyl 2026): `/ai-analiz` artık Mahallem sekmesi (Layout başlığı + alt çubuk); kendi
// kabuğunu çizen eski dört sekmeli sayfa `/ai-analiz/detay`.
// Büyük ölçülerin açık olduğu rotalar (ANASAYFA-BÜYÜT-1, PROFİL-BÜYÜT-1).
// Ölçüler `index.css` sonundaki `[data-boyut="buyuk"]` bloğunda; burada olmayan
// bir rotada öznitelik hiç basılmıyor, yani o sayfalara TEK kural değmiyor.
const BUYUK_ROTALAR = new Set(["/", "/profile"]);

const V2_ROTALARI = ["/acil-bildir", "/acil-vakalar", "/acil-merkezi", "/kayip-bildir", "/kayip-ilanlari", "/kaydettiklerim", "/ai-analiz/detay", "/mahalleler", "/kayip-kedi"];
// ACIL-02 (8 Eyl 2026): acil kaydin detay ekranlari (`AcilKayitDetay`) kendi
// basligini ciziyor (`KENDI_KABUGU = true`). Ustune Layout kendi basligini da
// koyarsa ekranda IKI baslik olur. Uc yol da tek parca kimlik tasiyor
// (`/injured-reports/<id>`) — esik 2.
// LANDING-1: `/mahalle/<ad>` reklam sayfası (tekil "mahalle/", `/mahallem` değil).
const V2_ON_EKLERI = ["/kayip/", "/bolge/", "/mahalle/", "/injured-reports/", "/danger-zones/", "/volunteer-calls/"];
const V2_EN_AZ_PARCA = {
  "/kayip/": 3, "/bolge/": 2, "/mahalle/": 2,
  "/injured-reports/": 2, "/danger-zones/": 2, "/volunteer-calls/": 2,
};
const v2mi = (yol) =>
  V2_ROTALARI.includes(yol) ||
  (V2_ON_EKLERI.some((o) => yol.startsWith(o) && parcaSayisi(yol) >= (V2_EN_AZ_PARCA[o] || 3))
   // Kendi BAŞLIĞINI çizen ekran "kabuksuz" DEĞİL: alt çubuğu Layout veriyor.
   // Bu satır olmadan iki kural çakışıyor ve alt çubuk yine kayboluyordu.
   && !kendiBasligiMi(yol));

export default function Layout({ children }) {
  const { t, lang, setLang } = useI18n();
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  // KÖPEK-3: global hayvan modu. Header markasına (StrayPaw) dokununca
  // Kedi/Köpek/Hepsi seçici açılır; seçim tüm listeleri/haritayı süzer.
  // Türkiye'de köpek gizli → toggle hiç gösterilmez.
  const [animalPickerOpen, setAnimalPickerOpen] = useState(false);
  const [animalMode, setAnimalModeState] = useState(getAnimalMode());
  // TUR-7: tek kapi. Ayni kosulun ikinci bir kopyasi kalmasin diye
  // animalMode.kopekAcikMi() cagriliyor; davranis birebir ayni.
  const dogAllowed = kopekAcikMi();

  // Unread direct-message count → drives the orange badge on the Messages tab.
  // Polls lightly and refetches on every navigation, so opening the thread (which
  // marks it read) clears the badge on the way back out.
  // Yoklama ortak hook'a tasindi: bu bilesen ve NotificationBell ayni ucu
  // ayri ayri yokluyordu. Gerekce: hooks/useOkunmamisSayac.js
  const { messages: unreadMsgs } = useOkunmamisSayac();

  // Rota degisiminde tazeleme KORUNDU: konusmayi acmak (okundu isaretler)
  // rozetin donuste temizlenmesini sagliyor. Hook alt sinirla koruyor, yani
  // hizli gezinmek uca yuk bindirmiyor.
  useEffect(() => {
    okunmamisTazele();
  }, [loc.pathname]);

  // ── BODY'NİN 80px ALT BOŞLUĞU — V2 ROTALARINDA ÖLÜ ALAN ─────────────────
  //
  // `index.css` body'ye `padding-bottom: 80px` koyuyor ("content never sits
  // under the dock"). V2 rotalarında dock ÇİZİLMİYOR (aşağıdaki
  // `!v2mi(...)` kapıları) ama boşluk duruyordu: her V2 sayfasının altında
  // 80px ölü alan.
  //
  // ÖLÇÜLDÜ, tahmin değil (5 Eyl 2026, `tezgah/dip-olc.mjs`):
  //   /kayip/s1/arama-alani @ iPhone-SE — içerik 814px bitiyor,
  //   belge 894px. Aradaki 80 body'nin.
  //
  // Yakalanışı öğretici: sabit alt çubuğun son satırı örtüp örtmediğini
  // ölçen denetimi yazdım, sayfanın kendi `pb`sini SIFIRLADIM ve denetim
  // YEŞİL kaldı. İşi body'nin 80'i yapıyordu, benim boşluğum değil. Yeşil
  // kalan bir bozma, denetimin ölçtüğü şeyin sandığım şey olmadığını
  // söyler.
  //
  // Desen deponun kendi çözümü (`Messenger.jsx` + `index.css`): `:has()`
  // modern WebView'da, sınıf eski WebView'da.
  useEffect(() => {
    const v2 = v2mi(loc.pathname);
    document.body.classList.toggle("v2-sayfa", v2);
    return () => document.body.classList.remove("v2-sayfa");
  }, [loc.pathname]);

  // Apply premium theme to <html data-theme="...">
  useEffect(() => {
    const isPremiumActive = !!(user?.is_premium && user?.premium_until);
    const theme = isPremiumActive ? (user?.theme || "warm_stone") : "warm_stone";
    document.documentElement.setAttribute("data-theme", theme);
  }, [user]);

  const emergencyBellRef = useRef(null);

  // Detect newly-earned badges on every route change and fire celebration.
  useBadgeCelebration(loc.pathname);

  // Global route progress bar — flashes a brief gradient line across the
  // top of the screen on EVERY internal navigation (Link, useNavigate,
  // bottom dock, etc.) for a consistent SPA "loading" feel.
  // The Acil Bildir <a href> click handler also toggles this class
  // pre-navigation so the bar appears even during a full-page reload.
  useEffect(() => {
    document.body.classList.add("route-loading");
    const t = setTimeout(() => document.body.classList.remove("route-loading"), 650);
    return () => clearTimeout(t);
  }, [loc.pathname]);

  return (
    <LiveCameraShutterProvider>
    {/* `data-v2-sayfa` — `index.css`teki `:has()` kuralının tutunacağı yer.
        Sınıf ile birlikte İKİ yol: `:has()` modern WebView'da, sınıf
        eskisinde. Deponun `messenger-detail` deseninin aynısı. */}
    <div className="min-h-screen flex flex-col bg-stone-50 text-stone-800"
      data-v2-sayfa={v2mi(loc.pathname) ? "1" : undefined}
      /* ANASAYFA-BÜYÜT-1 (17 Eyl 2026): büyük başlık, ACİL ve alt çubuk YALNIZ
         ana sayfada. Ölçüler `index.css` sonundaki `[data-boyut="buyuk"]`
         bloğunda; başka rotada öznitelik yok, yani hiçbir kural değmez.
         PROFİL-BÜYÜT-1 (18 Eyl 2026): /profile de eklendi — kullanıcının örnek
         ekranında başlık ×1,25 ölçüldü. Liste dışındaki sayfalar 0 piksel
         değişmiyor (tezgâh kapısı: DİĞER SAYFALAR AYNI). */
      data-boyut={BUYUK_ROTALAR.has(loc.pathname) ? "buyuk" : undefined}
      /* PROFİL-SAYAÇ-1 (18 Eyl 2026) — `data-baslik="iri"` GERİ ALINDI.
         PROFİL-BÜYÜT-1'de marka adı yalnız profilde 19 pt yapılmıştı. Kullanıcının
         cihaz ekranında (09:06) "Sokak Kedileri" İKİ SATIRA düşüp şeridi uzattı ve
         hero'daki adın üstüne bindi. Ölçüldü: 19 px'te gerçek yazı tipiyle 117,7 pt,
         YEDEK yazı tipiyle 148,8 pt yer gerekiyor; başlıkta marka adına kalan yer
         390'da 119 · 375'te 104 · 360'ta 89 pt. Yani cihazdaki yazı tipi ikamesiyle
         19 pt hiçbir genişlikte sığmıyor. Profil artık diğer sayfalarla aynı (16). */>

      {/* Top loading bar — flashes when user taps Acil Bildir so the
          full-page <a> navigation feels instant in Android WebView. */}
      <div className="route-progress" aria-hidden />

      {/* ─── Acil Bildir — STANDALONE, fixed top-right, plain <a> tag ───
          Rendered OUTSIDE the sticky header so no glass-nav backdrop-filter,
          transform, or overflow:hidden parent can swallow the tap in
          Android WebView. Uses native anchor (full-page navigation) — the
          most resilient tap target on any WebView version. */}
      {/* `/v2` ACIL hapini KENDI basliginda ciziyor (tasarimda serit icinde,
          sabit kose degil). Ikisi birden cizilirse iki ACIL ust uste biner. */}
      {/* ── ACİL HAPI DEĞİŞMEZ (kullanıcı kararı, 6 Eyl 2026) ──────────────
          Panolardaki ACİL hapı yer yer AI'ın kendi çizimi: kimi ekranda
          sayfanın üst çubuğunun içinde, düz kırmızı bir hap olarak duruyor.
          UYGULANMIYOR. Uygulamanın ACİL düğmesi tek ve orijinal: bu yüzen,
          parlayan hap. Kullanıcı bunu açıkça istedi — "acil butonumuz hep
          ayni kalacak ... biz elimizde ki orijinal tasarimi koruyacagiz".
          Bu yüzden `kendiBasligiMi` rotalarında da ÇİZİLİYOR; yalnız üstteki
          büyük başlık gizleniyor. */}
      {/* ── HEDEF DEĞİŞTİ: YENİ SİHİRBAZ (6 Eyl 2026) ─────────────────────
          Bu hap `/emergency-report`e gidiyordu. Yeni acil akışı
          (`/acil-bildir`, 1006 satır, dört kategori, üç adım) 5 Eylül'de
          yazıldı ama HİÇBİR YERDEN BAĞLI DEĞİLDİ: uygulamada ona giden bağ
          sayısı SIFIRDI. Kullanıcı haklı olarak "acil bildir yapmadık"
          diyordu — ekran vardı, kapısı yoktu.

          `?kategori=injured`: bu hapa basan kişi yaralı bir kedinin
          başında duruyor. Kategori ekranı boş açılsaydı, zaten bildiği şeyi
          seçmek zorunda kalırdı. Sihirbaz kategoriyi SEÇİLİ getiriyor ama
          adımı KENDİ İLERLETMİYOR (`bosDurum`un bilinçli kararı: bozuk bir
          bağdan gelen biri yanlış formun içinde bulmasın kendini).

          Hapın GÖRÜNÜŞÜ değişmedi — o kullanıcının kararı, 6 Eyl:
          "acil butonumuz hep ayni kalacak". Değişen yalnızca gittiği yer. */}
      {/* ACİL hapına DOKUNULMADI. Kullanıcı kararı (6 Eyl 2026):
          "acil butonumuz hep ayni kalacak". Kedi profili kabuksuz olsa da
          kurulu ACİL bileşeni yerinde kalır — pano ölçü verir, kurulu
          bileşenleri değiştirmez. */}
      {/* ═══ HARITA-1 · MADDE 18 (18 Eylül 2026) — HEDEF /acil-merkezi ═══
          KULLANICI KARARI. Yukarıdaki 6 Eylül notu SİLİNMİYOR ve hâlâ
          doğru: o gün hap `/emergency-report`ten `/acil-bildir`e alınmıştı
          çünkü yeni sihirbazın uygulamada HİÇ kapısı yoktu. Bugün o eksik
          kapanmış durumda; değişen ihtiyaç şu:

            "Header'daki ACİL butonu GLOBAL ACİL MERKEZİ'ne gider...
             Bu buton HARİTA FİLTRESİ DEĞİLDİR."

          Yani hap artık tek bir forma değil, dört işin toplandığı merkeze
          açılıyor (`AcilMerkezi.jsx`; rota `V2_ROTALARI`de zaten tanımlı):
          Acil Vakaları Gör · Acil Vaka Bildir · Yakındaki Acil Vakalar ·
          Yardım bekleyen vakalar.

          ⚠️ BEDELİ YAZILI: yaralı kedi bildirimi BİR DOKUNUŞ UZAKLAŞTI
          (ACİL → Acil Merkezi → Acil Vaka Bildir). `?kategori=injured`
          kısayolu kayboluyor. Kullanıcı bunu bilerek istedi.

          HAPIN GÖRÜNÜŞÜ DEĞİŞMEDİ — 6 Eylül'ün kuralı aynen: "acil
          butonumuz hep ayni kalacak, değişen yalnızca gittiği yer."

          ⚠️ HARİTADAKİ "ACİL" İLE KARIŞTIRMA: harita şeridindeki
          `toggle-sightings` çipi ve katman şeridindeki `katman-sightings`
          düğmesi YALNIZCA `show.sightings`i çeviriyor, hiçbir sayfaya
          gitmiyor. Tezgâhın ACİL AYRIMI kapısı ikisini birden ölçüyor. */}
      {/* ═══ 23 Eylül 2026 — HEDEF YENİDEN /acil-bildir (KULLANICI KARARI) ═══
          18 Eylül kararı geri alındı: *"acil bildir butonu acil merkezine
          çıkıyor, istediğimiz acil bildir sayfasının açılması… böylelikle
          insanlar uğraşmadan hemen o sayfaya çıkar."* Hap artık 5 seçenekli
          Acil Bildir formuna gidiyor (kategori ÖNSEÇİLMEZ — kullanıcı
          seçer). Acil Merkezi silinmedi; kapısı ana sayfadaki "Acil Merkezi"
          karosu ve Mahallem'in hızlı işlemi. */}
      {!v2mi(loc.pathname) && !kayitSihirbaziMi(loc.pathname, loc.state) && (
      <a
        href="/acil-bildir"
        className="emergency-mobile-link"
        data-testid="nav-emergencies-link"
        aria-label={t("nav.emergencies")}
        onClick={() => {
          // Don't preventDefault — let the native navigation happen. Everything
          // here is instant feedback for the beat before the WebView catches up.
          triggerEmergencyTapHaptic();
          playEmergencyBellShake(emergencyBellRef.current);
          document.body.classList.add("route-loading");
        }}
      >
        <span ref={emergencyBellRef} className="emergency-mobile-link__bell" aria-hidden>
          <BellRing size={21} strokeWidth={2.25} />
        </span>
        <span className="emergency-mobile-link__label">ACİL</span>
      </a>
      )}

      {/* KARAR 32'nin ikinci yarisi (9 Eyl 2026, cihaz olcumu).
          Alt cubuk, ACIL ve asistan kalkinca geriye IKI BASLIK kaldi:
          ustte Layout'un logolu basligi (Sokak Kedileri + slogan + TR/EN),
          hemen altinda sayfanin kendi "‹ Kedi Kaydet · 3/3" cubugu.
          Panoda TEK baslik var ve o sayfanin kendisi. Ayni hata 6 Eylul'de
          kayip ilaninda da cikmisti (kendiBasligiMi). */}
      <header className={`sticky top-0 z-40 glass-nav ${(mesajlasmaMi(loc.pathname) || v2mi(loc.pathname) || kendiBasligiMi(loc.pathname) || kayitSihirbaziMi(loc.pathname, loc.state)) ? "hidden" : ""}`} data-testid="app-header">
        {/* GÖVDE AYRI KANCALI. `app-header` güvenli alan dolgusunu İÇERİYOR
            (iPhone'da 56 css); tezgâh onu panonun durum çubuğu HARİÇ bandıyla
            karşılaştırınca 121 vs 57,5 diye 63 css'lik sahte bir fark çıktı.
            Ölçtüğün iki şeyin aynı şey olduğunu doğrulamadan farkı rapor etme.
            Panonun #1 bandı bu gövdeye denk gelir. */}
        <div data-testid="app-header-icerik" className="sk-baslik-govde max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between">
          <div className="flex min-w-0 items-center gap-2">
            <Link to="/" className="flex min-w-0 items-center gap-2.5 group" data-testid="logo-link">
              {/* Logo 44, 36 DEĞİL — panoda ölçüldü (pano5: 40,9→83,8 = 42,9;
                  pano4 aynı). 36'lık kare panonun ölçüsü değil, uygulamanın
                  eski alışkanlığıydı. */}
              <span className="h-11 w-11 shrink-0 rounded-[14px] overflow-hidden shadow-sm group-hover:rotate-[-6deg] transition-transform">
                <img src={markaLogosu(lang)} alt={markaAdi(lang)} className="w-full h-full object-cover" />
              </span>
              {/* Türkiye'de marka adı home linkinin içinde kalır (köpek yok). */}
              {/* `whitespace-nowrap` — 6 Eyl 2026, ÖLÇÜLDÜ. "Sokak Kedileri"
                  370 pt ve iPhone SE'de İKİ SATIRA düşüyordu (48 px), 65 px'lik
                  başlığın içinde. Pro Max'te tek satırdı, yani kusur yalnızca
                  DAR ekranlarda görünüyordu — en yaygın iki genişlikte.
                  Sığmama sebebi yer darlığı DEĞİLDİ: 370 pt'de başlık satırında
                  112 px boş yer var, ad 16 px'te 130 px istiyor ve kendisine 98
                  px ayrılmıştı. Flex, sarılabilen bir metni serbest yer dururken
                  sarıyordu. Panoda ad tek satır. */}
              {!dogAllowed && (
                <span className="min-w-0">
                  {/* 🔴 11 EYLÜL — MARKA ADI ARTIK ÜLKEYİ DE SORUYOR.
                    Kullanıcı: "Türkçeden İngilizceye geçince adımız StrayPaw
                    oluyor; Türkiye için işaretli olduğunda StrayCats'e
                    çevirebilir miyiz?" `t("appName")` yalnızca DİLE bakıyordu.
                    Karar `lib/marka.js`te tek yerde. */}
                <span data-testid="baslik-marka-adi" className="block font-display font-bold text-base leading-tight tracking-tight whitespace-nowrap">{markaAdi(lang)}</span>
                  {/* SLOGAN — panoda başlığın ikinci satırı. Olmadığı için
                      başlık tek satırlık bir şeride sıkışıyor ve panoya
                      benzemiyordu. `truncate`: dar ekranda ikinci satıra
                      düşüp başlığı büyütmesin. */}
                  <span data-testid="baslik-slogani" className="block truncate text-[11px] leading-tight text-stone-500">{t("baslikSlogani")}</span>
                </span>
              )}
            </Link>
            {/* KÖPEK-3: StrayPaw ülkelerinde marka adına dokun → Kedi/Köpek/Hepsi. */}
            {dogAllowed && (
              <button
                type="button"
                onClick={() => setAnimalPickerOpen(true)}
                data-testid="brand-animal-toggle"
                aria-label="Kedi / Köpek / Hepsi"
                className="font-display font-bold text-base tracking-tight flex items-center gap-1 hover:text-orange-600 transition-colors"
              >
                {markaAdi(lang)}
                <span className="text-sm" aria-hidden>{animalMode === "cats" ? "🐱" : animalMode === "dogs" ? "🐶" : "🐾"}</span>
              </button>
            )}
          </div>

          {/* ── TR/EN ANAHTARI GERİ GELDİ — 9 Eylül 2026, kullanıcı kararı ──
              7 Eylül'de başlıktan kaldırılıp Profil'e taşınmıştı; gerekçe
              yazılıydı ve doğruydu (panonun başlığında dil anahtarı yok, ve
              kaldırılmadan önce Profil'deki kapı doğrulanmıştı).

              Ama kullanıcı iki kez sordu: "en yukarıda eskiden olan Türkçe
              İngilizce butonumuz da yok." Uygulamayı beş dilde açan bir
              kişinin dilini değiştirmek için Profil'e gitmesi, ÖN KAPIDA
              çözülmesi gereken bir işi iki dokunuş öteye koyuyor.

              PROFİL'DEKİ SEÇİCİ DURUYOR — bu bir TAŞIMA değil, İKİNCİ bir
              kapı. Her ikisi de aynı listeden besleniyor (`dilSecimi.js`)
              ve aynı `setLang`i çağırıyor; ayrışmaları mümkün değil.

              LİSTE PROFİL'DEKİYLE AYNI (`secilebilirDiller`) ve aktif dil
              de İÇİNDE. İlk yazışımda "aktif dili gösterme" diye kurgulamıştım;
              test düşürdü — o işlev aktif dili bilerek listeye katıyor
              (yazılı gerekçe: "yoksa kullanıcı seçili dilini ekranda
              göremez"). Kardeş seçiciden ayrı bir mantık uydurmak, iki yerin
              zamanla ayrışması demekti. */}

          {/* ── TR/EN ANAHTARININ 7 EYLÜL'DEKİ KALDIRILMA NOTU ────────────
              Panoda başlıkta logo, ad ve slogan var; dil anahtarı YOK.
              Anahtar kaybolmuyor, PROFİL'e taşınıyor — orada zaten aynı
              listeden (`dilSecimi.js`) beslenen bir seçici duruyordu.
              Var olan bir yolu sessizce yok etmek, çalışmayan bir düğmeden
              beterdir; o yüzden önce kapının orada olduğu doğrulandı
              (Profile.jsx, `setLang`), sonra burası kaldırıldı.
              Yer açılınca sloganın satırı da sığdı. */}

          {/* ── TR/EN ANAHTARI GERİ GELDİ — 9 Eylül 2026, kullanıcı kararı ──
              7 Eylül'de (`3101d89e`) başlıktan kaldırılıp Profil'e taşınmıştı.
              Kullanıcı iki kez sordu; geri istendi ve GERİ KONDU.

              ⚠️ ÖNCE YANLIŞ YERE KOYDUM. Satırın sağ ucuna, `mr-28` OLMADAN.
              Cihazda HİÇ GÖRÜNMEDİ: ACİL hapı `position: fixed`, sağ üstte,
              `z-index: 99999` (index.css) — çipler onun ALTINDA kaldı.
              DOM'da vardı, ekranda yoktu; jsdom bu sınıfı göremez.

              Kullanıcı "önceki durduğu yerine alır mısın" dedi ve haklıydı:
              eski sürümde bu payın kendisi ÇÖZÜMDÜ, yorumu da bunu söylüyordu
              — "ACİL hapının solunda durur". Ölçüm zaten yapılmıştı; ben onu
              yeniden yazmaya kalkıp düşürmüştüm. Blok `3101d89e^`den BİREBİR
              geri alındı.

              Profil'deki seçici DURUYOR — bu bir taşıma değil, ikinci kapı;
              ikisi de `dilSecimi.js`ten besleniyor. */}
          <div
            className="flex items-center gap-[1px] bg-stone-100/90 backdrop-blur rounded-full
                       p-[2px] mr-28 shrink-0 shadow-sm border border-stone-200"
            data-testid="header-lang-toggle"
          >
            {secilebilirDiller(lang).map((lc) => (
              <button
                key={lc}
                type="button"
                onClick={() => setLang(lc)}
                aria-pressed={lang === lc}
                data-testid={`header-lang-${lc}`}
                // KÜÇÜLTÜLDÜ (9 Eyl 2026): geri koyduğum blok ESKİ düzenin
                // ölçüsüydü (px-2.5 py-1, 12 punto) ve yeni başlıkta sloganı
                // kırpıyordu — kullanıcı: "biraz daha küçült, alttaki yazıyı
                // bile kapatmış, artık yeni düzen daha minimal".
                //
                // GÖRÜNEN KÜÇÜK, DOKUNMA ALANI 44 — deponun kendi çözümü
                // (`AcilBildir`in geri oku, `FormParcalari`). Puntoyu
                // küçültüp dokunma hedefini de küçültmek, beyan edilmemiş bir
                // erişilebilirlik gerilemesi olurdu.
                //
                // ⚠️ 10 EYL 2026, CİHAZDA: ilk çözümüm `py-[13px] -my-[13px]`
                // idi ve EKRANDA BALON GİBİ DURDU (kullanıcı: "TR EN yazısı
                // ne kadar ilginç duruyor"). Sebep ölçüldü: negatif kenar
                // boşluğu DÜZENİ toplar ama KUTUYU KÜÇÜLTMEZ — düğme yine
                // ~36 punto yüksekliğinde ve `bg-white` o yüksekliği BOYUYOR.
                // Şerit ~15 punto olduğu için beyaz daire şeridin altından ve
                // üstünden 11'er punto taşıyordu.
                //
                // KURAL (taşınabilir): BOYAYAN KUTU BÜYÜTÜLMEZ. Dokunma
                // alanını saydam bir katman (`after:`) büyütüyor; boyanan
                // kutu şeridin içinde kalıyor. Görünen 20,5 punto, dokunulan
                // 46,5 punto — ikisi de yerinde.
                //
                // jsdom düzen hesaplamaz, yani hiçbir çizim kuralı bu taşmayı
                // göremez; bekçi `Layout.duman.test.jsx`te KAYNAĞA bakıyor.
                className={`relative min-w-[32px] px-[7px] py-[5px] rounded-full text-[10.5px] font-bold
                            leading-none transition-colors
                            after:content-[''] after:absolute after:left-0 after:right-0
                            after:top-[-13px] after:bottom-[-13px] ${
                  lang === lc ? "bg-white text-stone-900 shadow-sm" : "text-stone-500"
                }`}
              >
                {DIL_ETIKETLERI[lc] || lc.toUpperCase()}
              </button>
            ))}
          </div>

          {/* Acil Bildir is rendered OUTSIDE the header as a fixed
              top-right anchor (see below) so no header layer / glass-nav
              backdrop-filter can swallow the WebView tap.
              Messages access now lives inside the Mahallem page header
              so the bottom nav stays at the Golden 5. */}
        </div>
      </header>

      {/* KÖPEK-3: Kedi/Köpek/Hepsi seçici modalı (yalnızca StrayPaw ülkeleri). */}
      {dogAllowed && (
        <AnimalToggleModal
          isOpen={animalPickerOpen}
          onClose={() => setAnimalPickerOpen(false)}
          country={(() => { try { return getCountry().toUpperCase(); } catch { return "ID"; } })()}
          currentMode={animalMode}
          onSelect={(v) => setAnimalModeState(setAnimalMode(v))}
        />
      )}

      <main className="flex-1" data-testid="main-content">{children}</main>

      {/* Footer, tam ekran çalışan sayfalarda gizli.
          /messages: sohbet kutusu alt kenara kadar iniyor.
          /map: harita sayfanın kendisi; altında marka şeridi görünmesi haritayı
          yukarı sıkıştırıyordu ve alttaki + tuşuyla çakışıyordu. */}
      {/* ── WEB FOOTER KALDIRILDI — 6 Eylül 2026 ─────────────────────────
          Buradaki 119 satırlık footer (KEŞFET / TOPLULUK / İLETİŞİM
          sütunları + telif satırı) artık çizilmiyor.

          ÖLÇÜLDÜ, tahmin edilmedi: `/mahallem` 370 pt'de 1498 CSS px'ti;
          footer y=865'te başlıyor ve **553 px** yer kaplıyordu — sayfanın
          %37'si. Tasarım panosunda böyle bir blok YOK, ve `/` artık
          `AnasayfaV2`, yani uygulamanın ön kapısı da bir web sayfası değil.

          ÜÇ ŞEY BUNA BAĞLIYDI, üçü de önce güvenceye alındı:
            • Gizlilik/KVKK — Profil'de zaten doğrudan satırdı.
            • Kullanım Şartları ve İletişim — footer en görünür girişleriydi;
              6 Eyl'de Profil'e DOĞRUDAN satır olarak kondu (bu sırayla:
              önce kapı, sonra kaldırma). Bekçi: `rotalar.kapi.test.js`
              "YASAL ÜÇLÜ Profil'de DOĞRUDAN satır".
            • Statik sayfalar (Yardım, Hakkımızda, Gizlilik, Şartlar) zaten
              birbirine bağlanıyor; oradaki bağlantılar duruyor.

          YAN KAZANÇ: `dokunma-denetimi.mjs`in yıllardır beyan ettiği en
          küçük dokunma hedefi bu footer'ın "Gizlilik Politikası" bağlantısı
          (88×13 CSS px) idi. Blok gidince o sapma da gitti.

          GERİ DÖNÜŞ: bu blok `git` geçmişinde duruyor; geri isteyen bir
          karar çıkarsa oradan alınır. Yorumda saklamak, ölü 119 satırı
          dosyada tutmak olurdu. */}

      {/* BOTTOM NAV — visible on all screen sizes. On mobile it spans full
          width pinned to the edge; on desktop it floats as a centered dock
          (max-width capped, glass effect, gentle gap from screen bottom). */}
      {/* `/v2` alt barini KENDI ciziyor (orta dugme "Kedi bildir",
          tasarim geregi). Ikisi birden cizilirse iki bar ust uste biner. */}
      {/* KEDİ PROFİLİ İSTİSNA DEĞİL (6 Eyl akşamı, kullanıcı kararı):
          ana alt bar profilde de çizilir — orta "Kedi bildir" düğmesi
          uygulamanın en çok dokunulan yeri ve profilde de erişilebilir
          olmalı. Profilin kendi sekme çubuğu ÜSTE oturuyor; ikisi
          binişmesin diye o çubuk `--sk-altbar-yuksekligi` kadar kalkıyor
          (index.css). Başlık ise profilde hâlâ gizli: sayfanın kendi
          hero fotoğrafı ve ‹ oku var. */}
      {!v2mi(loc.pathname) && !sohbetEkraniMi(loc.pathname)
        && !kayitSihirbaziMi(loc.pathname, loc.state) && (
      <nav
        className="fixed bottom-0 left-0 right-0 md:bottom-4 md:left-1/2 md:right-auto md:-translate-x-1/2 md:max-w-md md:rounded-2xl md:shadow-2xl z-40 mobile-bottom-nav"
        data-testid="mobile-bottom-nav"
      >
        <div className="grid grid-cols-5 h-16 items-end">
          {[
            { to: "/", label: t("nav.home") || "Anasayfa", icon: Home, key: "home" },
            // 16 Eyl 2026 — ETİKET GİTTİĞİ YERİ SÖYLÜYOR. Bu satır üç kez
            // değişti (a4ac5bef → 1e318904 → bf889033) ve her turda asıl
            // kusur AYNIYDI: iki ayrı bölüm tek adı paylaşıyordu. Kullanıcı
            // kararı (16 Eyl): harita bölümü "Harita", sosyal akış "Pati Ağı".
            // Çakışma artık `adCakismasi.test.js` tarafından tutuluyor —
            // bir kelimeyi çivilemek yerine İKİ ADIN AYRI KALMASI ölçülüyor,
            // çünkü çivilenen kelime iki kez geri alındı.
            { to: "/map", label: t("nav.map") || "Harita", icon: MapPin, key: "map" },
            // The big centre button is the front door to the whole app: point a
            // camera, and the AI searches the database before it lets you file a
            // new cat. That flow lives at /scan-cat. It USED to point at
            // /identify, a "Yakında / bakımda" placeholder from the period CLIP
            // was disabled — so the loudest button in the app opened a dead end
            // and dumped people onto the manual form. The flow works now; send
            // them to it.
            // 1 Ağu 2026: yapay zeka düğmesi artık YENİ akışa gidiyor.
            // Eski `/scan-cat` (yuvarlak kılavuz + "Canlı kamerayı aç" ara
            // ekranı) kullanıcının açıkça kaldırılmasını istediği sayfaydı.
            // Rota duruyor, kayıt sihirbazı orada güvende; yalnızca ana
            // giriş buradan çevrildi. GERİ DÖNÜŞ = bu satırı `/scan-cat`
            // yapmak, tek satır.
            // ⚠️ 6 EYL 2026 — ORTA DÜĞME ARTIK "YZ TANI" DEĞİL, "KEDİ BİLDİR".
            // Yukarıdaki iki paragraf 1 Ağustos'un kaydı; tarihsel, geçerli
            // değil. Karar ve gerekçesi TEK YERDE: `lib/altBar.js`. Hedef de
            // etiket de oradan okunuyor — `AnasayfaV2` kendi alt barını
            // çiziyor ve ikisinin ayrı düşmemesi için ikisi de aynı sabiti
            // kullanıyor (`aramaKapsam.test.js` bunu denetliyor).
            // "Yapay Zeka Tanı" kaybolmadı: hamburger menüde ve Landing
            // footer'ında duruyor, yalnızca alt barın merkezinden çıktı.
            { to: ORTA_DUGME, label: t(ORTA_ETIKET) || "Kedi bildir", icon: Plus, key: "report", center: true },
            { to: user ? "/mesajlar" : "/login", label: t("nav.messages") || "Mesajlar", icon: MessageSquare, key: "messages" },
            { to: user ? "/profile" : "/login", label: t("nav.profile"), icon: UserCircle2, key: "profile" },
          ].map((item) => {
            const Icon = item.icon;
            const active =
              item.to === "/"
                ? loc.pathname === "/"
                : loc.pathname.startsWith(item.to);
            if (item.center) {
              return (
                <Link
                  key={item.key}
                  to={item.to}
                  data-testid={`mobile-nav-${item.key}`}
                  className="relative flex items-center justify-center"
                >
                  {/* Soft pulsing glow ring behind the primary action. */}
                  <span
                    aria-hidden
                    className="absolute -top-3 w-16 h-16 rounded-full bg-orange-500 opacity-60 blur-lg cta-identify-pulse"
                  />
                  <span
                    className={`relative w-16 h-16 rounded-full grid place-items-center shadow-2xl shadow-orange-900/45 ring-4 ring-white -translate-y-4 transition-transform active:scale-95 ${
                      active ? "bg-orange-700" : "bg-orange-600 hover:bg-orange-700"
                    }`}
                  >
                    <Icon size={28} strokeWidth={2.2} className="text-white cta-identify-sparkle" />
                  </span>
                  {/* Mini label under the floating disc */}
                  <span className="absolute -bottom-0.5 text-[10px] font-bold text-orange-700 truncate max-w-[64px]">
                    {item.label}
                  </span>
                </Link>
              );
            }
            const hasUnread = item.key === "messages" && unreadMsgs > 0;
            return (
              <Link
                key={item.key}
                to={item.to}
                data-testid={`mobile-nav-${item.key}`}
                className={`flex flex-col items-center justify-center gap-0.5 h-full transition-colors ${
                  active || hasUnread ? "text-orange-600" : "text-stone-500 hover:text-stone-900"
                }`}
              >
                <span className="relative">
                  <Icon size={hasUnread ? 22 : 20} className={hasUnread ? "transition-all" : ""} />
                  {hasUnread && (
                    <span
                      data-testid="mobile-nav-messages-badge"
                      className="absolute -top-2 -right-2.5 min-w-[17px] h-[17px] px-1 rounded-full bg-orange-600 text-white text-[10px] font-bold leading-[17px] text-center ring-2 ring-white animate-pulse"
                    >
                      {unreadMsgs > 9 ? "9+" : unreadMsgs}
                    </span>
                  )}
                </span>
                <span className="text-[10px] font-medium truncate max-w-[64px]">{item.label}</span>{/* 64px: 375px ekranda hucre 75px, yan etikete 60px yerine 64px vermek
                    guvenli. pt-br "Mensagens" 57px idi, 60px yuvada 3px payla
                    kaliyordu — yazi tipi degisince kesilirdi (4 Eyl 2026 olcumu). */}
              </Link>
            );
          })}
        </div>

      </nav>
      )}

      {/* Pati Asistan — floating fab to the right of the bottom dock.
          Stays accessible without intruding on the 5-item primary nav. */}
      {/* OLCUM-01: /v2 tasariminda yuzen asistan dugmesi yok; olcumde
          aksiyon karolarinin ustune biniyordu. */}
      {!v2mi(loc.pathname) && !kediProfiliMi(loc.pathname) && !sohbetEkraniMi(loc.pathname)
        && !kayitSihirbaziMi(loc.pathname, loc.state) && <PatiAsistan />}

      {/* Live upload progress — floats above the dock when a photo POST
          is in flight. Auto-hides on completion / failure. */}
      <UploadProgressBar />

      {/* Cat-count milestone modal — 1st, 5th, 10th, 25th tiers */}
      <CatMilestoneModal />
    </div>
    </LiveCameraShutterProvider>
  );
}
